import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import typeOf from '../../../../helpers/typeOf';

export function DashboardToday({ data, getData }) {
    useEffect(() => {
        getData();
    }, [getData]);

    const sort = useMemo(
        () => ['PublisherCreditTotalAmountConfirmed', 'ActionTypeLeadCountConfirmed', 'ActionTypeSaleCountConfirmed', 'Visits'],
        []
    );

    return (
        <div className="column">
            {sort.map((key) => {
                const item = data?.[key] || {};
                const level = item.diff > 0 ? 'level-up' : item.diff < 0 ? 'level-down' : '';

                return (
                    <div className="ibox today" key={key}>
                        <div className="inner">
                            <h5>{item.title}</h5>
                            <div className="ibox-content">
                                <div className="stat-percent">
                                    {item.subTitle} {item.diff}% <i className={`levels ${level}`} />
                                </div>
                                <div className="stat-value">
                                    {typeOf.isString(item.today) ? Parser(item.today) : item.today}
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

DashboardToday.propTypes = {
    data: PropTypes.object,
    getData: PropTypes.func.isRequired
};

DashboardToday.defaultProps = {
    data: {}
};

export default DashboardToday;
